import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { ModuleKey } from '../../constants/constants';

const usePermission = () => {
  const pillars = useSelector((state) => state?.auth?.permissions || []);
  const getModulePermission = useCallback(
    (pillarKey, moduleKey, permissionKey) => {
      const moduleKeyLower = ModuleKey?.[moduleKey]
        ? ModuleKey[moduleKey]?.toLowerCase()
        : moduleKey?.toLowerCase();

      if (!pillarKey || !moduleKeyLower || !permissionKey) return false;
      // Ensure pillars is an array before calling find
      if (!Array.isArray(pillars)) return false;
      const pillar = pillars?.find((p) => p.key?.toLowerCase() === pillarKey?.toLowerCase());
      if (!pillar || pillar?.isActive === false || pillar?.isActive === 'false') return false;

      const module = pillar?.modules?.find((m) => m.key?.toLowerCase() === moduleKeyLower);
      if (!module || module?.isActive === false || module?.isActive === 'false') return false;

      return module?.permissions?.some(
        (perm) =>
          perm?.key?.toLowerCase() === permissionKey?.toLowerCase() &&
          (perm?.isActive === true || perm?.isActive === 'true')
      );
    },
    [pillars]
  );

  return { getModulePermission };
};

export default usePermission;
